import { request } from "../client";

export interface ConsentReportPayload {
  consentId: string;
  preferences: Record<string, boolean>;
  timestamp: number;
  version: number | string;
  isEU?: boolean;
}

export interface ConsentRecord {
  consentId?: string;
  preferences: Record<string, boolean>;
  timestamp: number; // ms since epoch
  version: number | string;
  isEU?: boolean;
  source?: string;
}

export function createPrivacyEndpoints(baseUrl: string): {
  reportConsent: (
    payload: ConsentReportPayload,
    token?: string | null,
  ) => Promise<{ success: boolean }>;
  getLatestConsent: (token?: string | null) => Promise<ConsentRecord | null>;
} {
  return {
    reportConsent(
      payload: ConsentReportPayload,
      token?: string | null,
    ): Promise<{ success: boolean }> {
      return request<{ success: boolean }>(baseUrl, "/privacy/consent", {
        method: "POST",
        body: payload,
        token,
      });
    },
    getLatestConsent(token?: string | null): Promise<ConsentRecord | null> {
      return request<ConsentRecord | null>(baseUrl, "/privacy/consent", {
        method: "GET",
        token,
      });
    },
  };
}
